module.exports = __webpack_public_path__ + "img/aba_no.48c90668.png";